export function useModalVisibility(setModalLoadingOpen: (open: boolean) => void) {
  return function setModalVisibility(shouldShow: boolean) {
    setModalLoadingOpen(shouldShow);
  };
}
